import { useEffect, useMemo, useState } from 'react';
import useGetSignedUrl from './useGetSignedUrl';
import { getPreviewFormUrl } from '../api/PreviewDomainAPI';
const useSignedPreviewUrl = ({
  previewDomain,
  previewRequestData,
  isUngatedForInvoicePreview = false,
  skip = false
}) => {
  const [urlError, setUrlError] = useState();
  const previewUrl = useMemo(() => {
    return previewDomain ? getPreviewFormUrl(previewDomain, isUngatedForInvoicePreview) : '';
  }, [previewDomain, isUngatedForInvoicePreview]);
  const shouldSkipSigning = skip || !previewDomain || !isUngatedForInvoicePreview;
  const {
    signUrl,
    data: signedUrlData,
    loading: signedUrlLoading,
    error: signedUrlError
  } = useGetSignedUrl({
    skip: shouldSkipSigning
  });
  useEffect(() => {
    if (!shouldSkipSigning && previewUrl && previewRequestData && !signedUrlData && !signedUrlLoading) {
      signUrl({
        variables: {
          unsignedUrl: previewUrl,
          formData: {
            previewInvoiceRequest: [JSON.stringify(previewRequestData)]
          },
          httpMethod: 'POST'
        }
      }).catch(setUrlError);
    }
  }, [shouldSkipSigning, previewUrl, previewRequestData, signUrl, signedUrlData, signedUrlLoading]);
  const canSubmitSignedForm = useMemo(() => !shouldSkipSigning && Boolean(signedUrlData === null || signedUrlData === void 0 ? void 0 : signedUrlData.signedUrl) && !signedUrlLoading, [shouldSkipSigning, signedUrlData, signedUrlLoading]);
  return {
    signedUrl: signedUrlData === null || signedUrlData === void 0 ? void 0 : signedUrlData.signedUrl,
    loading: signedUrlLoading,
    error: signedUrlError || urlError,
    canSubmitSignedForm
  };
};
export default useSignedPreviewUrl;